import React from "react";
import { makeStyles, Grid, Typography, IconButton } from "@material-ui/core";
import { CircleArrowFowardIcon, CircleArrowDownIcon } from "../icons";

export default function ProductCard(props) {
  const { onClick, option, mini, index, product, open, openCard, linkToFile } =
    props;
  const classes = useStyles({
    mini,
    showOption: open === index,
    linkToFile,
    ...props,
  })();
  // console.log({ product });
  return (
    <Grid
      container
      className={classes.box}
      onClick={!mini ? () => openCard() : onClick}
    >
      <div>
        <Typography className={classes.text}>{option}</Typography>
      </div>
      <div>
        <IconButton>
          {open !== index ? <CircleArrowFowardIcon /> : <CircleArrowDownIcon />}
        </IconButton>
      </div>

      {!mini && open === index && (
        <Grid item sm={12} xs={12}>
          {option === "Contraindicaciones" ? (
            <>
              <Typography
                dangerouslySetInnerHTML={{
                  __html: product.contraIndications,
                }}
              />
            </>
          ) : (
            <Typography>
              {/*
Composición
Indicaciones
Presentaciones
Concentración
Registro
Precio
              */}
              {option === "Composición" && product.molecule}
              {option === "Indicaciones" && product.indications}
              {option === "Presentaciones" && product.presentation}
              {option === "Concentración" && product.concentration}
              {option === "Registro" && product.isp}
              {option === "Precio" && product.price}
              {/* product.presentation */}
            </Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
}

const useStyles = ({ mini, showOption, linkToFile, ...props }) =>
  makeStyles((theme) => ({
    box: {
      background: "#FFFFFF",
      boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
      borderRadius: 22,
      width: "100%",
      height: mini
        ? 43
        : showOption
        ? "fit-content"
        : linkToFile
        ? "unset"
        : 55,
      padding: mini ? "0 13px" : 13,
      cursor: "pointer",
      [theme.breakpoints.up("md")]: {
        alignItems: "center",
      },
      "& div": {
        height: linkToFile ? "unset" : "100%",
        width: "80%",
        [theme.breakpoints.up("md")]: {
          width: "90%",
        },
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        "& p": {
          fontSize: mini ? "0.688rem" : "1rem",
          lineHeight: mini ? "0.813rem" : "1.125rem",
          fontWeight: mini ? "bold" : "500",
          color: theme.palette.primary.main,
        },
      },
      "& div:nth-child(2)": {
        width: "20%",
        "& img": {
          objectFit: "contain",
        },
        [theme.breakpoints.up("md")]: {
          width: "10%",
        },
      },
    },
    text: {
      hyphens: "auto",
      width: "100%",
      wordWrap: "normal",
      "-moz-hyphens": "none",
      "overflow-wrap": "break-word",
      "-webkit-hyphens": "none",
    },
  }));
